import { computed } from 'vue';

import { ReviewProvider } from '@thehotelsnetwork/personalization-types';

export function useProvidersItems(items: ReviewProvider[]) {
  return computed(() => items.map((provider) => ({
    name: provider.reviewer,
    totalReviews: provider.totalReviews,
    value: {
      score: provider.userScore,
      max: provider.maxScore,
    },
  })));
}
